import type { Rect } from "@yjsgames/safe-area";

export interface WorldMoveConfirmLayout {
  readonly panel: Rect;
  readonly title: Rect;
  readonly close: Rect;
  readonly body: Rect;
  readonly yesButton: Rect;
  readonly noButton: Rect;
}

export const WORLD_MOVE_CONFIRM_PANEL_W = 300;
export const WORLD_MOVE_CONFIRM_PANEL_H = 260;

const PANEL_PAD_X = 20;
const TITLE_H = 28;
const CLOSE_SIZE = 36;
const BODY_H = 112;
const BUTTON_W = 108;
const BUTTON_H = 24;

export function resolveWorldMoveConfirmLayout(screenWidth: number, screenHeight: number): WorldMoveConfirmLayout {
  const cx = screenWidth / 2;
  const cy = screenHeight / 2;
  const panelX = cx - WORLD_MOVE_CONFIRM_PANEL_W / 2;
  const panelY = cy - WORLD_MOVE_CONFIRM_PANEL_H / 2;
  const titleRightGuard = 44;
  return {
    panel: {
      x: panelX,
      y: panelY,
      width: WORLD_MOVE_CONFIRM_PANEL_W,
      height: WORLD_MOVE_CONFIRM_PANEL_H,
    },
    title: {
      x: panelX + titleRightGuard,
      y: panelY + 8,
      width: WORLD_MOVE_CONFIRM_PANEL_W - titleRightGuard * 2,
      height: TITLE_H,
    },
    close: {
      x: panelX + WORLD_MOVE_CONFIRM_PANEL_W - CLOSE_SIZE - 2,
      y: panelY + 2,
      width: CLOSE_SIZE,
      height: CLOSE_SIZE,
    },
    body: {
      x: panelX + PANEL_PAD_X,
      y: panelY + 60,
      width: WORLD_MOVE_CONFIRM_PANEL_W - PANEL_PAD_X * 2,
      height: BODY_H,
    },
    yesButton: {
      x: cx - 62 - BUTTON_W / 2,
      y: panelY + WORLD_MOVE_CONFIRM_PANEL_H - 40,
      width: BUTTON_W,
      height: BUTTON_H,
    },
    noButton: {
      x: cx + 62 - BUTTON_W / 2,
      y: panelY + WORLD_MOVE_CONFIRM_PANEL_H - 40,
      width: BUTTON_W,
      height: BUTTON_H,
    },
  };
}
